<template>
  <div class="relative bg-gray-100 rounded shadow drop-shadow px-6 py-4 flex flex-col">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Card"
}
</script>